import { gql } from '@apollo/client';

export const NOTIFICATIONS_QUERY = gql`
    query notifications( $page: Int!, $pageSize: Int ) {
        notifications( page: $page, pageSize: $pageSize ) {
            pagination 
            totalReturned
            edges {
                node {
                    id
                    isSticky
                    isFeatured
                    isPublished
                    publishAt 
                    unpublishAt 
                    unfeatureAt
                    weight
                    brandIds
                    createdAt
                    locales {
                        code
                        name
                        description
                    }
                }
            }

        }   
    }
`;
